"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_DOCUMENTS_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.CAROUSEL_DOCUMENTS_QUERY = (0, client_1.gql) `
  query getCarouselDocuments($propertyId: ID!) {
    property(propertyId: $propertyId) {
      id
      streetViewEnabled
      coverImageDocumentUploadId
      documentUploads(filterProcessing: true, carouselDocumentsOnly: true) {
        id
        accountDocumentType {
          id
          name
        }
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q2Fyb3VzZWxEb2N1bWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0NvbW1vbi9DYXJvdXNlbC9fX3F1ZXJpZXNfXy9nZXRDYXJvdXNlbERvY3VtZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyQ0FBcUM7QUFFeEIsUUFBQSx3QkFBd0IsR0FBRyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7O0NBZTFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBncWwgfSBmcm9tIFwiQGFwb2xsby9jbGllbnRcIjtcblxuZXhwb3J0IGNvbnN0IENBUk9VU0VMX0RPQ1VNRU5UU19RVUVSWSA9IGdxbGBcbiAgcXVlcnkgZ2V0Q2Fyb3VzZWxEb2N1bWVudHMoJHByb3BlcnR5SWQ6IElEISkge1xuICAgIHByb3BlcnR5KHByb3BlcnR5SWQ6ICRwcm9wZXJ0eUlkKSB7XG4gICAgICBpZFxuICAgICAgc3RyZWV0Vmlld0VuYWJsZWRcbiAgICAgIGNvdmVySW1hZ2VEb2N1bWVudFVwbG9hZElkXG4gICAgICBkb2N1bWVudFVwbG9hZHMoZmlsdGVyUHJvY2Vzc2luZzogdHJ1ZSwgY2Fyb3VzZWxEb2N1bWVudHNPbmx5OiB0cnVlKSB7XG4gICAgICAgIGlkXG4gICAgICAgIGFjY291bnREb2N1bWVudFR5cGUge1xuICAgICAgICAgIGlkXG4gICAgICAgICAgbmFtZVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5gO1xuIl19